import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {Observable} from "rxjs";
import {UsageService} from "../../services/usage.service";


@IonicPage()
@Component({
  selector: 'page-usage',
  templateUrl: 'usage.html',
})
export class UsagePage {

 acknowledgment$ : Observable<string>;

  constructor(public navCtrl: NavController,
              public usageService: UsageService,
              public navParams: NavParams) {
    this.acknowledgment$ = this.usageService.get();
  }

  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/usage/usage.ts